export default __webpack_public_path__ + "images/new_examples-AwEam.png";